import React, { useEffect, useState } from "react";
import Popup from "../../../../components/popup/Popup";
import VerificationPopUp from "../../../../sections/VerificationPop/VerificationPopUp";
import {
  AdminMainText,
  AdminHeaderAction,
  AdminFormSecondaryAction,
} from "../../../AdminDashboard/shared/adminUx";

const GeneraComponet = ({ heading, image, status }) => {
  const [link, setLink] = useState(false);
  const [ShowCrossButton] = useState(true);

  useEffect(() => {
    if (link) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = "auto";
    }
  }, [link]);

  return (
    <>
      <div className="w-fit mx-auto">
        <div className="flex justify-center">
          <img
            className="w-[100px] h-[60px] md:w-[120px] md:h-[80px]"
            src={image}
            alt={heading || "Association"}
          />
        </div>
        <div className="flex justify-center my-3">
          <AdminMainText className="text-offblack text-center">{heading}</AdminMainText>
        </div>
        <div className="flex justify-center">
          {status === "Remove" ? (
            <AdminFormSecondaryAction type="button" onClick={() => setLink(true)}>
              {status}
            </AdminFormSecondaryAction>
          ) : (
            <AdminHeaderAction type="button" onClick={() => setLink(true)}>
              {status}
            </AdminHeaderAction>
          )}
        </div>
      </div>
      {link && (
        <Popup setTrigger={() => setLink(false)} ShowCrossButton={ShowCrossButton}>
          <VerificationPopUp
            closePopup={() => setLink(false)}
            resendButton={true}
            firstMainHeading="Connect your association profile"
            label="Association Profile URL"
            placeholder="Paste the URL of your association profile here."
            secondMainHeading="Association profile linked"
            secondP="Success! Your association has been linked. This connection enhances credibility and helps your profile stand out."
            smallPara="By linking your association profile, you allow Trades Poster to display your profile on our platform, which may increase customer engagement. We assure you that your information is securely handled in compliance with privacy regulations."
            buttonText="Save"
          />
        </Popup>
      )}
    </>
  );
};

export default GeneraComponet;
